import { createRoutine } from "../utils/routine.utils";
import { createAction } from "redux-act";
export var getCards = createRoutine("CARDS_GET");
export var selectUserType = createAction("SELECT_USER_TYPE");
export var generateExtraCards = createRoutine("GENERATE_EXTRA_CARDS");
export var cardActionCallback = createRoutine("CARD_ACTION_CALLBACK");
export var cardActionDeeplink = createRoutine("CARD_ACTION_DEEPLINK");
export var closeCard = createRoutine("CARD_CLOSE");
export var closeIndexContractCards = createRoutine("CLOSE_INDEX_CONTRACT_CARDS");
